import { render, staticRenderFns } from "./calendarControlAttendant.vue?vue&type=template&id=d5b4e106&"
import script from "./calendarControlAttendant.js?vue&type=script&lang=js&"
export * from "./calendarControlAttendant.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5b4e106')) {
      api.createRecord('d5b4e106', component.options)
    } else {
      api.reload('d5b4e106', component.options)
    }
    module.hot.accept("./calendarControlAttendant.vue?vue&type=template&id=d5b4e106&", function () {
      api.rerender('d5b4e106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/calendarControlAttendant.vue"
export default component.exports